import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-incidencias',
  templateUrl: './incidencias.component.html',
  styleUrls: ['./incidencias.component.scss']
})
export class IncidenciasComponent implements OnInit {

  // FECHAS
  date_desde: string = new Date().toISOString().slice(0, 10);
  date_hasta: string = new Date().toISOString().slice(0, 10);

  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date_desde = dateStr
  };

  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => { this.date_hasta = dateStr; }
  };

  incidencias: any[] = [];

  constructor(public rest: RestService) { }

  ngOnInit() {
    this.GetData();
  }


  GetIncidencias() {
    this.rest.GetIncidencias(this.date_desde, this.date_hasta)
    .subscribe( (data) => {
      this.incidencias = data['data'];
    });
  }

  GetData(){
    this.GetIncidencias();
  }

}
